import {createSelector} from 'reselect'
import * as app from '../../application.selectors';

const facilityStatuses = createSelector(
  state => state.periods.entities.facilityStatus,
  statuses => statuses
);

export const periods = createSelector(
  state => state.periods.entities.periods,
  app.userFacility,
  facilityStatuses,
  (periods, facility, statuses) => {
    return Object.keys(periods).map(key => {

      const status = statuses[`${key}/${facility.id}`] || {status: 'Awaiting Sample', statusValue: 1};
      return ({
        ...periods[key],
        facilityStatus: {
          name: status.status,
          value: status.statusValue
        }
      });
    })
  }
);
export const periodsInYear = createSelector(
  state => state.periods.entities.periods,
  app.userFacility,
  facilityStatuses,
  (periods, facility, statuses, year) => {
    return Object.keys(periods.filter(p => {
      const dateStr = p.periodStart.replace("Z", "");
      return year === new Date(dateStr).getFullYear();
    })).map(key => {

      const status = statuses[`${key}/${facility.id}`] || {status: 'Awaiting Sample', statusValue: 1};
      return ({
        ...periods[key],
        facilityStatus: {
          name: status.status,
          value: status.statusValue
        }
      });
    })
  }
);



// WEBPACK FOOTER //
// ./src/modules/periods/period.selectors.js